module.exports = __webpack_public_path__ + "23_sigir.jpg?04b4f66aeaf4de27ffecc06852a90aaf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_sigir.jpg
// module id = 204
// module chunks = 0